import React, { useEffect, useState } from "react";
import { alpha } from "@material-ui/core/styles";

const SensorContentAnimation = ({
  color,
  width = 200,
  height = 100,
  percentage = 0,
  isActive = true,
  amplitude = 3,
  speed = 0.02,
  uniqueId = "content-animation"
}) => {
  const [waveOffset, setWaveOffset] = useState(0);

  // Animation loop for content waves
  useEffect(() => {
    let animationFrame;

    const animate = () => {
      setWaveOffset(prev => prev + speed);
      animationFrame = requestAnimationFrame(animate);
    };

    if (isActive && percentage > 0) {
      animationFrame = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [isActive, percentage, speed]);

  // wave path for content animation
  const generateWavePath = (waveAmplitude = amplitude) => {
    const points = [];

    for (let x = 0; x <= width; x += 2) {
      const y =
        Math.sin(x * 0.02 + waveOffset) * waveAmplitude +
        Math.sin(x * 0.03 + waveOffset * 0.7) * waveAmplitude * 0.6 +
        Math.sin(x * 0.015 + waveOffset * 1.3) * waveAmplitude * 0.3;
      points.push(`${x},${y}`);
    }
    if (points.length === 0) {
      // Handle the case where there are no points to draw
      return `M 0,0 L 0,0 L ${width},50 L 0,50 Z`;
    }
    return `M 0,${points[0].split(",")[1]} L ${points.join(
      " L "
    )} L ${width},50 L 0,50 Z`;
  };

  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: "100%",
        overflow: "hidden"
      }}
    >
      <svg
        width="100%"
        height="100%"
        style={{ position: "absolute", bottom: 0 }}
        preserveAspectRatio="none"
        viewBox={`0 0 ${width} ${height}`}
      >
        <defs>
          {/* Liquid gradient */}
          <linearGradient
            id={`liquidGradient-${uniqueId}`}
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stopColor={alpha(color, 0.9)} />
            <stop offset="50%" stopColor={color} />
            <stop offset="100%" stopColor={alpha(color, 0.8)} />
          </linearGradient>

          {/* Glow effect */}
          <filter id={`glow-${uniqueId}`}>
            <feGaussianBlur stdDeviation="1" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Main liquid body */}
        <rect
          x="0"
          y="10"
          width="100%"
          height="90"
          fill={`url(#liquidGradient-${uniqueId})`}
        />

        {/* Animated wave surface */}
        <path
          d={generateWavePath()}
          fill={color}
          fillOpacity="0.9"
          filter={`url(#glow-${uniqueId})`}
        />

        {/* Surface reflection */}
        <path
          d={generateWavePath(amplitude * 0.5)}
          fill="black"
          fillOpacity="0.05"
          transform="translate(0, 3)"
        />
      </svg>
    </div>
  );
};

export default SensorContentAnimation;
